/**
 * Helpers for the "User Assigned Zones" of a user.
 *
 * A user can only be assigned zones which are assigned to one of the user's members. By default all
 * zones of the assigned members are assigned to the user, but the selection can be restricted to a
 * subset of them.
 */

/**
 * Returns the distinct zones of the given members, sorted by the zone code.
 */
export const extractMemberZones = (members) => {
    const zonesByCode = new Map();
    (members || []).forEach((member) => (member.zones || []).forEach((zone) => zonesByCode.set(zone.code, zone)));
    return [...zonesByCode.values()].sort((a, b) => a.code.localeCompare(b.code));
};

/**
 * Converts the given zones into items of the assigned zones checkbox list.
 */
export const createZoneItems = (zones) => zones.map((zone) => ({ id: zone.code, label: `${zone.name} (${zone.code})` }));

/**
 * Recalculates the assigned zone codes when the member assignment of a user changes. Zones of newly
 * assigned members are assigned to the user by default, while zones which are no longer provided by
 * any of the assigned members are dropped.
 */
export const syncAssignedZonesWithMembers = (assignedZoneCodes, previousMembers, newMembers) => {
    const previousMemberIds = (previousMembers || []).map((previousMember) => previousMember.memberId);
    const addedMembers = (newMembers || []).filter((newMember) => !previousMemberIds.includes(newMember.memberId));
    const availableZoneCodes = extractMemberZones(newMembers).map((zone) => zone.code);
    const addedZoneCodes = extractMemberZones(addedMembers).map((zone) => zone.code);
    return [...new Set([
        ...(assignedZoneCodes || []).filter((zoneCode) => availableZoneCodes.includes(zoneCode)),
        ...addedZoneCodes,
    ])];
};
